import './NavList-5dc067e3.css';

var navListClasses = {"GroupHeading":"prc-NavList-GroupHeading-KIlSv"};

export { navListClasses as default };
